import type { ReactNode } from "react";

import { HoverHintDefinitionGrid, skuQuantityPeekRows } from "@/components/ui/HoverHintDefinitionGrid";
import { HoverHintContent } from "@/components/ui/title-help";

import type { FirmwareSerialDeviceSkuCount } from "./firmwareApi";

export function FirmwareSerialDeviceCountHint({
  bySku,
  children,
}: {
  bySku: FirmwareSerialDeviceSkuCount[];
  children: ReactNode;
}) {
  return (
    <HoverHintContent
      hoverHint={
        bySku.length > 0 ? (
          <HoverHintDefinitionGrid
            rows={skuQuantityPeekRows(bySku.map((row) => ({ sku: row.sku, quantity: row.count })))}
          />
        ) : (
          <p>No SKU breakdown for this count.</p>
        )
      }
    >
      {children}
    </HoverHintContent>
  );
}
